import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { HttpResponse } from '@angular/common/http';
import { Servico } from '../models/servico.model';
import { Wrapper } from '../models/wrapper.model';
import { environment } from 'environments/environment';

@Injectable()
export class ServicoService {
    private http = inject(HttpClient);

    
    securityApi = `${environment.api}/svc-security/api`;

    servicos(page = 0, size = 10, isVisibleForm = false): Observable<Wrapper<{ items: Servico[] }>> {
        let baseUri =  `${this.securityApi}/servico?skip=${(page - 1) * size}&take=${size}`;

        if(isVisibleForm) {
            baseUri += `&isVisibleForm=${isVisibleForm}`;
        }
        return this.http.get<Wrapper<{ items: Servico[] }>>(baseUri);
    }
    save(servico: Servico): Observable<Servico> {
        delete servico.idenServ;
        return this.http.post<Servico>(`${this.securityApi}/servico`, servico);
    }

    update(servico: Servico): Observable<Servico> {
        return this.http.put<Servico>(`${this.securityApi}/servico/${servico.idenServ}`, servico);
    }

    get(servicoId: string): Observable<Wrapper<Servico>> {
        return this.http.get<Wrapper<Servico>>(`${this.securityApi}/servico/${servicoId}`);
    }

    remove(servicoId: string): Observable<Servico> {
        return this.http.delete<Servico>(`${this.securityApi}/servico/${servicoId}`);
    }

}
